module.exports = "<div  \r\n    id=\"{{$ctrl.name}}\"\r\n    class=\"imr-accordion-item\"\r\n>\r\n    <ng-transclude></ng-transclude>\r\n</div>"